<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
$( document ).ready(function() {
  setTimeout(function() {
        var getHeight = $('.productView-image-wrapper').height();
        console.log(getHeight);
        $('.productView-thumbnail-wrapper .slick-list').css('max-height', getHeight + 'px');
    }, 1000); 
});

$(document).on('click', '.no-megamenu .menu-lv-1__action', (event) => {
  //event.preventDefault();
     const hash = $(event.currentTarget).attr('href').split('#')[1];
           if (hash != undefined && hash != '' && $(`#${hash}`).length) {
                    $('body').removeClass('menu_open');
                    $('html, body').animate({
                        scrollTop: $(`#${hash}`).offset().top - 30
                    }, 700);
          }
})